import { styled, useTheme } from '@mui/material';
import { QuestionOption } from '../../../../../../../types';
import { OptionWrapper } from '../common';
import { Radio } from '../../../../../../../components/Radio/Radio';
import { NotesBoxPopup } from '../../../../../../../components/NotesBoxPopup/NotesBoxPopup';
import { Typography } from '../../../../../../../components/Typography/Typography';

interface Props {
  option: QuestionOption;
  isChecked: boolean;
  selectedOption: QuestionOption;
}

const TextWrapper = styled('div')`
  position: relative;
`;

export const RadioOption = ({ option, isChecked, selectedOption }: Props) => {
  const { colors } = useTheme();

  return (
    <OptionWrapper>
      <Radio checked={isChecked} disabled sx={{ '&.Mui-checked': { color: colors.primary[60] } }} />
      <NotesBoxPopup
        notes={selectedOption?.notes || ''}
        popupPlacement='right-start'
        popupOffset={{ mainAxis: 8, crossAxis: -8 }}
      >
        <TextWrapper>
          <Typography
            variant='caption'
            color={colors.primary[70]}
            style={{ background: selectedOption?.notes ? colors.warning[20] : 'transparent' }}
          >
            {option.name}
          </Typography>
        </TextWrapper>
      </NotesBoxPopup>
    </OptionWrapper>
  );
};
